import { Add } from "@mui/icons-material";
import { Box, Typography, Button, Chip } from "@mui/material";
import React, { useState } from "react";
import { commonContainerWrapper } from "../../Common/styles/flex";
import { NoDataContainer } from "../../Common/styles/table";
import AddTagModal from "./AddTagModal";

const tagKey = (tag: { id: string; studyId?: string | null }) =>
  `${tag.studyId ?? "registry"}-${tag.id}`;

const TagsCard = ({
  tagsList,
  refreshPage,
  canEdit = false,
}: {
  tagsList: any[];
  refreshPage: () => void;
  canEdit: boolean;
}) => {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Box sx={{ ...commonContainerWrapper, mt: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h2" color="text.primary">
          Tags
        </Typography>
        {canEdit && (
          <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              Add Tag
            </Button>
          </Box>
        )}
      </Box>
      {tagsList.length > 0 && (
        <Box sx={{ mt: 3, display: "flex", gap: 2, flexWrap: "wrap" }}>
          {tagsList.map((tag) => (
            <Chip
              sx={{
                backgroundColor: "#F6F1F8",
                paddingX: "10px",
                paddingY: "2px",
                borderRadius: "6px",
                fontSize: 14,
                fontWeight: 600,
                color: "primary.main",
                m: 0.5,
              }}
              key={tagKey(tag)}
              label={tag.name}
            />
          ))}
        </Box>
      )}
      {tagsList.length === 0 && (
        <NoDataContainer>
          <Typography variant="body1" color="gray">
            No Data
          </Typography>
        </NoDataContainer>
      )}

      {showModal && (
        <AddTagModal
          showModal={showModal}
          closeModal={handleCloseModal}
          refreshPage={refreshPage}
          existingTags={tagsList}
        />
      )}
    </Box>
  );
};

export default TagsCard;
